// ==============================|| THIN SCROLLBAR ||============================== //

// sx fragment for scroll panes: a thin pill that only shows while the pointer is over the pane.
// Both browsers' native scrollbars are obtrusive inside a panel (a thick dark bar on Firefox/GTK, a wide
// opaque one with a visible track on Chrome), so we normalise them to one look.
//
// The standard properties drive Firefox and Chrome 121+; the latter then ignores the -webkit-
// pseudo-elements, which remain for older Chrome/Safari. Note that `scrollbar-color` costs Firefox its
// auto-hiding overlay scrollbar, so the gutter is permanently reserved — the transparent thumb is what
// keeps it invisible until hover.
//
// Usage: sx={{ overflowY: 'auto', ...thinScrollbar(theme) }}
const thinScrollbar = (theme) => ({
  scrollbarWidth: 'thin',
  scrollbarColor: 'transparent transparent',
  '&:hover': { scrollbarColor: `${theme.palette.grey[300]} transparent` },
  '&::-webkit-scrollbar': { width: 8, height: 8 },
  '&::-webkit-scrollbar-track': { backgroundColor: 'transparent' },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'transparent',
    borderRadius: 8,
    // inset the thumb so it reads as a thin pill rather than a full-width bar
    border: '2px solid transparent',
    backgroundClip: 'content-box',
    transition: theme.transitions.create('background-color'),
  },
  '&:hover::-webkit-scrollbar-thumb': { backgroundColor: theme.palette.grey[300] },
  '&::-webkit-scrollbar-thumb:hover': { backgroundColor: theme.palette.grey[500] },
})

export default thinScrollbar
